import { useTheme } from 'styled-components';

import { MedicalDeviceOrderStatus } from '@dreryk/egabinet-ezwm-frontend-api';

import { Message, MessageOptions } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';

type StatusOptionBean = Omit<Record<MedicalDeviceOrderStatus, any>, 'NOT_SENT' | 'INCORRECT'>;
const useMessageOptions = (): MessageOptions<StatusOptionBean> => {
   const theme = useTheme();
   return {
      ACCEPTED: {
         color: theme.success,
         backgroundColor: theme.successLighter,
         labelColor: theme.textBody,
      },
      COMPLETED: {
         color: theme.success,
         backgroundColor: theme.successLighter,
         labelColor: theme.textBody,
      },
      REJECTED: {
         color: theme.error,
         backgroundColor: theme.errorLighter,
         labelColor: theme.textBody,
      },
      CANCELLED: {
         color: theme.error,
         backgroundColor: theme.errorLighter,
         labelColor: theme.textBody,
      },
      VERIFICATION: {
         color: theme.info,
         backgroundColor: theme.infoLighter,
         labelColor: theme.textBody,
      },
      PAPER: {
         color: theme.primary,
         backgroundColor: theme.primaryLighter,
         labelColor: theme.textBody,
      },
   };
};

export type MedicalDeviceApplicableStatuses = keyof StatusOptionBean;
type StatusCellProps = {
   readonly id: number;
   readonly medicalDeviceOrderStatus: MedicalDeviceApplicableStatuses;
};

export const StatusCell = (props: StatusCellProps): JSX.Element => {
   return (
      <Message<StatusOptionBean>
         testId={`status-order-${props.id}`}
         options={useMessageOptions()}
         type={props.medicalDeviceOrderStatus}
         label={medicalDevicesTranslationKeys.historicalMedicalDeviceOrder.orderStatus[props.medicalDeviceOrderStatus]}
         displayIndicator
      />
   );
};
